import { createStore } from 'vuex';
import createPersistedState from "vuex-persistedstate";
import webApiProxy from "@/services/webApiProxy.js";
import {DataRowToValidateDTO} from "@/scripts/DTO/DataRowToValidateDTO.js";
import {DataPersRowToValidateDTO} from "@/scripts/DTO/DataPersRowToValidateDTO";
import {InsertRequestDTO, InsertRowDTO} from "@/scripts/DTO/InsertRequestDTO.js";
import {InsertPersRequestDTO, InsertPersRowDTO} from "@/scripts/DTO/InsertPersRequestDTO.js";

export default createStore({
    state: {
        schedaAppData: null,
        variantiDisponibili: [],
        variantiProdotto: [],
        validatedRows: [],
        validatedPersRows: [],
        validatedReimbusto: null,
        loggedUserInfo: null,
        messagePrimeAlreadyShown:false,
        userSessionId:'',
        datiMagazzino: null,
        listaMagazzini: [],
        posizioniStampa: [],
        seReimbustoRichiesto: false,
        idConfigurazioneRigheCorrente: null,
    },
    plugins: [
        //se faccio refresh della pagina perdo lo state. In questo modo riesco a tenerlo in vita nel cookie 
        //https://stackoverflow.com/questions/43027499/vuex-state-on-page-refresh
        //https://github.com/robinvdvleuten/vuex-persistedstate/tree/3.x.x
        createPersistedState({
            storage: window.sessionStorage
            /*storage: {
                getState: (key) => Cookies.getJSON(key),
                setState: (key, state) => Cookies.set(key, state, { expires: 3, secure: true })
                // getItem: (key) => Cookies.get(key),
                // // Please see https://github.com/js-cookie/js-cookie#json, on how to handle JSON.
                // setItem: (key, value) =>
                //     Cookies.set(key, value, { expires: 3, secure: true }),
                // removeItem: (key) => Cookies.remove(key),
              }, */
        })
    ],
    mutations : {
        SET_SCHEDA_APP_DATA(state, schedaAppData){
            state.schedaAppData = schedaAppData;
        },
        SET_VALIDATED_ROWS(state, rows){
            state.validatedRows = rows;
        },
        RESET_VALIDATED_ROWS(state){
            state.validatedRows = [];
        },
        SET_VALIDATED_PERS_ROWS(state, persRows){
            state.validatedPersRows = persRows;
        },
        RESET_VALIDATED_PERS_ROWS(state){
            state.validatedPersRows = [];
        },
        SET_VALIDATED_REIMBUSTO(state, reimbusto){
            state.validatedReimbusto = reimbusto;
        },
        RESET_VALIDATED_REIMBUSTO(state){
            state.validatedReimbusto = null;
        },
        SET_LOGGED_USER_INFO(state, userInfo){
            state.loggedUserInfo = userInfo;
        },
        SET_MESSAGE_PRIME_ALREADY_SHOWN(state, seMessagePrimeAlreadyShown){
            state.messagePrimeAlreadyShown = seMessagePrimeAlreadyShown;
        },
        SET_SESSION_ID(state, sessionId){
            state.userSessionId = sessionId;
        },
        SET_VARIANTI_DISPONIBILI(state, varDisponibili){
            state.variantiDisponibili = varDisponibili;
        },
        SET_MAGAZZINO_SELEZIONATO(state, magazzinoSelezionato){
            state.datiMagazzino = magazzinoSelezionato;
        },
        SET_LISTA_MAGAZZINI(state, listaMagazziniToSet){
            state.listaMagazzini = listaMagazziniToSet;
        },
        SET_VARIANTI_PRODOTTO(state, varProdotto){
            state.variantiProdotto = varProdotto;
        },
        SET_POSIZIONI_STAMPA(state, posizioniStampa){
            state.posizioniStampa = posizioniStampa;
        },
        SET_SE_REIMBUSTO_RICHIESTO(state, seReimbustoRichiesto){
            state.seReimbustoRichiesto = seReimbustoRichiesto;
        },
        SET_ID_CONFIGURAZIONE(state, idConfigurazione){
            state.idConfigurazioneRigheCorrente = idConfigurazione;
        },
        SET_ACCETTAZIONE_PRIVACY(state, flagSeCondPrivacyAccettate){
            if(state.loggedUserInfo != null){
                state.loggedUserInfo.CustomerData.FlagPrivacy = flagSeCondPrivacyAccettate;
            }
        },
        SET_ACCETTAZIONE_COND_VEND(state, flagSeCondVendGeneraliAccettate, flagSeCondVendParticolariAccettate){
            if(state.loggedUserInfo != null){
                state.loggedUserInfo.CustomerData.FlagCondizioniGenerali = flagSeCondVendGeneraliAccettate;
                state.loggedUserInfo.CustomerData.FlagCondizioniParticolari = flagSeCondVendParticolariAccettate;
                state.loggedUserInfo.CustomerData.DataLogCondizioniGenerali = new Date();
                state.loggedUserInfo.CustomerData.DataLogCondizioniParticolari = new Date();
            }
        }
    },
    actions: {
        async setSchedaData({commit}, requestedScheda){
            const dnnData = window.dnnAppData;
            return await webApiProxy.getData(requestedScheda.codListino, requestedScheda.codVar, dnnData.schedaTabId, dnnData.defaultTabIdIfError, dnnData.schedaSettings, dnnData.requestUrl)
                .then(res =>{
                    commit('SET_SCHEDA_APP_DATA', res.data);
                })
                .catch(error =>{
                    throw(error);        
                });
        },
        async setValidatedRows({commit}, validationObj){
            
            let dataRows = [];
            let dataPersRows = [];

            validationObj.rows.forEach((element) => {
                element.quantitaAllocate.filter(x => x.quantita > 0).forEach((articoloQta) => {
                    let dtoObj = new DataRowToValidateDTO();
                    dtoObj.ProdottoInfo = validationObj.variantiProdotto.filter(x => x.CodVar1 === element.codVar1 && x.CodVar2 === articoloQta.codVar2)[0];
                    dtoObj.Quantita = articoloQta.quantita;
                    dtoObj.CodiceDeposito = validationObj.codMagazzino;
                    dataRows.push(dtoObj);
                })
            })
 
            validationObj.posizioniStampaRows.forEach((persElem) => {
                let dtoPersObj = new DataPersRowToValidateDTO();
                dtoPersObj.CodicePers = persElem.codColoreSelezionato;
                dtoPersObj.QtaPezzi = validationObj.totPezzi;
                dtoPersObj.CodicePosizioneStampa = persElem.posData.Codice;
                dataPersRows.push(dtoPersObj);
            });

            let idAzienda = this.state.loggedUserInfo ? this.state.loggedUserInfo.IdAzienda : -1; //dnnData.isAuthenticated ? dnnData.idAzienda : -1;

            return await webApiProxy.validateRows(dataRows, dataPersRows, validationObj.sePersonalizzare, idAzienda, validationObj.seMerceCampione)
             .then(response => {
                let objResponse = response.data;
                commit('SET_VALIDATED_ROWS', objResponse.Rows);
                commit('SET_VALIDATED_PERS_ROWS', objResponse.PersonalizzazioniRows);
                return objResponse;
             })
             .catch(error => {
                 throw(error);
             });
        },
        async setValidatedArtReimbusto({commit}, articoloToValidate){
            let requestDto = {
                CodiceArticolo: articoloToValidate.codArticolo,
                QuantitaPezzi: articoloToValidate.quantitaPezzi,
                IdAzienda: this.state.loggedUserInfo ? this.state.loggedUserInfo.IdAzienda : -1,
                SeMerceCampione: false
            };

            return await webApiProxy.validateArticolo(requestDto).then(response => {
                let objResponse = response.data;
                commit('SET_VALIDATED_REIMBUSTO', objResponse);
                return objResponse;
            })
            .catch(error => {
                throw(error);
            });
        },
        async getLoggedUser({commit}) {

            const dnnData = window.dnnAppData;
            if(dnnData.userSessionId !== this.state.userSessionId){
                commit('SET_SESSION_ID', dnnData.userSessionId);
                commit('SET_MESSAGE_PRIME_ALREADY_SHOWN', false);
            }

            let requestDto = {
                LoadCustomerInfo: (this.state.loggedUserInfo === null || (this.state.loggedUserInfo !== null && this.state.loggedUserInfo.CustomerData === null))
            };

            return await webApiProxy.loggedUser(requestDto)
                .then(res => {
                    if(res.data){
                        if(!requestDto.LoadCustomerInfo && this.state.loggedUserInfo !== null){
                            res.data.CustomerData = this.state.loggedUserInfo.CustomerData;
                        }
                        commit('SET_LOGGED_USER_INFO', res.data);
                    }
                    else {
                        commit('SET_LOGGED_USER_INFO', null);
                        commit('SET_MESSAGE_PRIME_ALREADY_SHOWN', false);
                    }
                })
                .catch(error => {
                    throw(error);
                })
        },
        setLoggedUserInfo({commit}, userRequestDTO){
            return webApiProxy.loginUser(userRequestDTO)
                .then(res => {
                    //salvo nello state il UserInfo dell'utente appena loggato
                    if(res.data.LoginSuccess){
                        commit('SET_LOGGED_USER_INFO', res.data.UserInfo);
                    }
                    
                    return res.data;
                })
                .catch(error => {
                    throw(error);
                })
        },
        setMessagePrimeAlreadyShown({commit}, messageAlreadyShown){
            commit('SET_MESSAGE_PRIME_ALREADY_SHOWN', messageAlreadyShown);
        },
        async insertPersRowsToCart({commit}){
            let requestDto = new InsertPersRequestDTO();
            let errors = [];
            
            for(let idx = 0; idx < this.state.validatedPersRows.length; idx++){ // const element in this.state.validatedPersRows){
                let element = this.state.validatedPersRows[idx];
                let datiPosizione = this.state.posizioniStampa.filter(x => x.posData.Codice === element.CodicePosizioneStampa)[0];
                if(datiPosizione !== undefined){

                    let rowPersDtoObj = new InsertPersRowDTO();
                    rowPersDtoObj.IdConfigurazione = this.state.idConfigurazioneRigheCorrente;
                    rowPersDtoObj.CodicePersonalizzazione = datiPosizione.codPersSelezionata;
                    rowPersDtoObj.NomeLogo = datiPosizione.nomeLogo;
                    rowPersDtoObj.CodNumColoriDaStampare = element.CodicePers;
                    rowPersDtoObj.CodPosizioneStampa = datiPosizione.posData.Codice;
                    rowPersDtoObj.RelativePathFileLogo = '';
                    rowPersDtoObj.PostInvioLogo = datiPosizione.caricaLogoPosticipato;
                    rowPersDtoObj.Note = datiPosizione.note;
                    
                    rowPersDtoObj.CodCatNumColoriDaStampare = datiPosizione.codCatColoreSelezionato;
                    rowPersDtoObj.Prezzo = element.Prezzo;
                    rowPersDtoObj.DescPersonalizzazione = datiPosizione.descPersSelezionata;
                    rowPersDtoObj.DescNumColoriDaStampare = datiPosizione.descColoreSelezionato;
                    rowPersDtoObj.DescPosizioneStampa = datiPosizione.posData.Posizione;
                    rowPersDtoObj.MaxMisuraBase = datiPosizione.posData.Base;
                    rowPersDtoObj.MaxMisuraAltezza = datiPosizione.posData.Altezza;
                    rowPersDtoObj.CodiceIva = element.CodiceIva;

                    if(datiPosizione.logoCaricato){
                        let objectDto = {
                            IdConfigurazione:this.state.idConfigurazioneRigheCorrente,
                            IdAzienda:this.state.loggedUserInfo ? this.state.loggedUserInfo.IdAzienda : -1,
                            CodPosizioneStampa:datiPosizione.posData.Codice,
                            NomeLogo:datiPosizione.nomeLogo,
                            BasePathDirectoryUploadLogo: this.state.schedaAppData.basePathFileUploadLogoPers
                        };
    
                        let formData = new FormData();
                        formData.append('filesToUpload', datiPosizione.fileLogo);
                        formData.append('objectDto', JSON.stringify(objectDto));
                        await webApiProxy.uploadFileLogo(formData)
                            .then((res) => {
                                if(!res.data.IsError){
                                    console.log('File caricato con successo!!');
                                    rowPersDtoObj.RelativePathFileLogo = res.data.RelativePathAndFileNameSaved;
                                }
                                else{
                                    errors.push(`Errore caricamento file per logo "${datiPosizione.nomeLogo}".`);
                                }
                            })
                            .catch(error => {
                                console.log(`Errore caricamento file: ${error}`);
                                errors.push(`Errore caricamento file per logo "${datiPosizione.nomeLogo}": ${error}`);
                            })
                    }

                    requestDto.PersRowsToInsert.push(rowPersDtoObj);
                }
            }

            if(errors.length > 0){
                throw(errors);
            }

            //se loghi caricati correttamente salvo le personalizzazioni a db
            return await webApiProxy.insertPersRowsToCart(requestDto)
                .then(res => {
                    if(res.data.InsertResultOk){
                        //resetto le righe personalizzazioni validate
                        commit('RESET_VALIDATED_PERS_ROWS');
                        commit('SET_POSIZIONI_STAMPA', []);
                        //commit('SET_ID_CONFIGURAZIONE', null);
                    }

                    return res.data;
                })
                .catch(error => {
                    throw(error);
                });
        },
        async insertRowsToCart({commit}, params){
            let requestDto = new InsertRequestDTO();
            requestDto.IdAzienda = this.state.loggedUserInfo ? this.state.loggedUserInfo.IdAzienda : -1;
            this.state.validatedRows.forEach((element) => {
                let rowDtoObj = new InsertRowDTO();
                rowDtoObj.ProdottoInfo = element.ProdottoInfo;
                rowDtoObj.Quantita = element.Quantita;
                rowDtoObj.Prezzo = element.Prezzo;
                rowDtoObj.CodiceDeposito = element.CodiceDeposito;
                rowDtoObj.IdConfigurazione = element.IdConfigurazione;
                rowDtoObj.DataEvasione = element.DataEvasioneVariante;
                rowDtoObj.SePersonalizzare = params.sePersonalizzare;
                rowDtoObj.SeArticoloServizio = params.seArticoloServizio;
                rowDtoObj.SeMerceCampione = params.seMerceCampione;
                rowDtoObj.SeMerceFullCustom = params.seMerceFullCustom;
                rowDtoObj.NextStepCarrello = params.nextStepCarrello;
                rowDtoObj.SeReimbusto = params.seReimbusto;
                rowDtoObj.PrezzoReimbusto = params.prezzoReimbusto;
                rowDtoObj.CodiceIva = element.CodiceIva;
                rowDtoObj.CodiceIvaReimbusto = params.codiceIvaReimbusto;
                
                requestDto.RowsToInsert.push(rowDtoObj);
            });

            return await webApiProxy.insertRowsToCart(requestDto)
                .then(res => {
                    if(res.data.InsertResultOk){
                        //resetto le righe validate
                        commit('RESET_VALIDATED_ROWS');
                        commit('SET_ID_CONFIGURAZIONE', res.data.IdConfigurazioneRighe);
                    }

                    return res.data;
                })
                .catch(error => {
                    throw(error);
                });
        },
        async rinunciaCarrello({dispatch}){ //commit,

            let idConfig = this.state.idConfigurazioneRigheCorrente;
            let resDeleteRighe = await webApiProxy.deleteCartRows({ RecordNumber:null, IdDocumento:null, IdConfigurazione:idConfig })
                .then(res => {
                    return res.data;
                })
                .catch(error => {
                    throw(error);
                });

            let resDeleteRighePers = await webApiProxy.deleteCartPersRows({ RecordNumber:null, IdConfigurazione:idConfig })
                .then(res => {
                    return res.data;
                })
                .catch(error => {
                    throw(error);
                });

            if(!resDeleteRighe.isError && !resDeleteRighePers.isError){
                //resetto tutto: righe carrello, righe personalizzazioni, reimbusto,...
                dispatch('resetCarrelloData');
                return '';
            }
            else{
                let errMsg = '';
                if(resDeleteRighe.isError) {
                    errMsg += `${resDeleteRighe.errorMsg}<br />`;
                }
                if(resDeleteRighePers.isError){
                    errMsg += `${resDeleteRighePers.errorMsg}<br />`;
                }
                return errMsg;
            }
        },
        resetValidatedRows({commit}){
            //resetto le righe validate
            commit('RESET_VALIDATED_ROWS');
        },
        resetValidatedPersRows({commit}){
            //resetto le righe personalizzazioni validate
            commit('RESET_VALIDATED_PERS_ROWS');
        },
        resetValidatedArtReimbusto({commit}){
            //resetto l'articolo validato reimbusto
            commit('RESET_VALIDATED_REIMBUSTO');
        },
        setVariantiDisponibili({commit}, varDisponibili){
            commit('SET_VARIANTI_DISPONIBILI', varDisponibili);
        },
        setMagazzinoSelezionato({commit}, magazzinoSelezionato){
            commit('SET_MAGAZZINO_SELEZIONATO', magazzinoSelezionato);
        },
        setListaMagazzini({commit}, listaMagazziniData){
            commit('SET_LISTA_MAGAZZINI', listaMagazziniData);
        },
        setVariantiProdotto({commit}, variantiProd){
            commit('SET_VARIANTI_PRODOTTO', variantiProd);
        },
        setPosizioniStampa({commit}, posStampa){
            commit('SET_POSIZIONI_STAMPA', posStampa);
        },
        setReimbustoRichiesto({commit}, value){
            commit('SET_SE_REIMBUSTO_RICHIESTO', value);
        },
        resetCarrelloData({commit}){
            commit('SET_SCHEDA_APP_DATA', null);
            commit('SET_MAGAZZINO_SELEZIONATO', null);
            commit('SET_LISTA_MAGAZZINI', []);
            commit('SET_VARIANTI_DISPONIBILI', []);
            commit('SET_VARIANTI_PRODOTTO', []);
            commit('RESET_VALIDATED_ROWS');
            commit('RESET_VALIDATED_PERS_ROWS');
            commit('RESET_VALIDATED_REIMBUSTO');
            commit('SET_POSIZIONI_STAMPA', []);
            commit('SET_SE_REIMBUSTO_RICHIESTO', false);
            commit('SET_ID_CONFIGURAZIONE', null);
        },
        setAccettazionePrivacyUtente({commit}, flagSeCondPrivacyAccettate){
            commit('SET_ACCETTAZIONE_PRIVACY', flagSeCondPrivacyAccettate);
        },
        setAccettazioneCondVendUtente({commit}, flagSeCondVendGeneraliAccettate, flagSeCondVendParticolariAccettate){
            commit('SET_ACCETTAZIONE_COND_VEND', flagSeCondVendGeneraliAccettate, flagSeCondVendParticolariAccettate);
        }
    }
  })
